import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { TenantListItem } from '../../api/queries';
import classes from './TenantTable.module.css';
import { Routes } from '../../enums/Routes';
import { formatNorwegianDate } from '../../utils/dateFormatters';

interface TenantTableProps {
  tenants: TenantListItem[];
}

const formatNumber = (num: number | null): string => {
  if (num === null) return '∞';
  return num.toLocaleString('no-NO');
};

export const TenantTable = ({ tenants }: TenantTableProps): ReactElement => {
  const navigate = useNavigate();

  const handleRowClick = (tenantId: number) => {
    navigate(Routes.SystemAdminTenantDetail.replace(':tenantId', tenantId.toString()));
  };

  const handleKeyDown = (event: React.KeyboardEvent, tenantId: number) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleRowClick(tenantId);
    }
  };

  return (
    <div className={classes.tableContainer}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>Kunde</th>
            <th>Eier</th>
            <th>Opprettet</th>
            <th>Team</th>
            <th>SMS</th>
            <th>Lisenser</th>
          </tr>
        </thead>
        <tbody>
          {tenants.map((tenant) => (
            <tr
              key={tenant.id}
              onClick={() => handleRowClick(tenant.id)}
              onKeyDown={(e) => handleKeyDown(e, tenant.id)}
              tabIndex={0}
              className={classes.clickableRow}
              role="button"
              aria-label={`Åpne detaljer for ${tenant.name}`}
            >
              <td className={classes.nameCell}>
                <strong>{tenant.name}</strong>
              </td>
              <td>{tenant.partnerName || 'Trustpulse'}</td>
              <td>{formatNorwegianDate(tenant.createdAt)}</td>
              <td>{tenant.teamCount}</td>
              <td>
                {tenant.smsQuota === null || tenant.smsQuota === 0
                  ? 'Deaktivert'
                  : `${formatNumber(tenant.smsUsed)} / ${formatNumber(tenant.smsQuota)}`}
              </td>
              <td>
                {tenant.availableSeats === null || tenant.availableSeats === 0
                  ? 'Ubegrenset'
                  : `${formatNumber(tenant.seatsUsed)} / ${formatNumber(tenant.availableSeats)}`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
